import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { identitySyncNotifier } from '@/ws';
import { useProfileQuery } from '@/queries/user';
import { resolveIdentitySyncRelevance } from './resolveIdentitySyncRelevance';
import { getIdentitySyncFailedMessage } from './identitySyncMessages';
import { IdentitySyncRouteConfig } from './identitySyncRouteConfig.types';

export const useIdentitySyncFailedNotifications = (config: IdentitySyncRouteConfig) => {
  const { pathname } = useLocation();
  const { data: profile } = useProfileQuery();

  useEffect(() => {
    return identitySyncNotifier.on((message) => {
      const relevance = resolveIdentitySyncRelevance(message, pathname, profile, config);
      if (!relevance.isRelevant) return;

      toast.error(getIdentitySyncFailedMessage(message.operationType));
      relevance.invalidate();
    });
  }, [config, pathname, profile]);
};
